import type { HttpMock } from '#e2e-utils/mockScenarios';
import { ControllerStatus } from '#models/ControllerStatus.enum';
import type { ControllerDetails } from '#services/cve/ControllerDetails';
import { IterationStatusCode, LineOfBusiness, VettingIteration } from '#services/cve/VettingIteration';

const reputationalRiskDetails: ControllerDetails = {
  statusCode: ControllerStatus.MANUAL_CHECK_REQUIRED,
  controlCode: 'ReputationalRisk',
  check: {
    requestDateTime: '2023-05-18T13:29:56.409Z',
    responseDateTime: '2023-05-18T13:29:56.409Z',
    requestorId: 'CVE',
    expirationDateTime: '2025-09-26T00:00:00.000Z',
    controlData: {},
  },
};

export const repRiskSavedMocks: HttpMock[] = [
  {
    request: {
      method: 'GET',
      urlPathPattern: '^/iterations/iterationId$',
    },
    response: {
      status: 200,
      body: {
        iterationId: 'iterationId',
        lineOfBusiness: LineOfBusiness.TCI,
        companyId: '113',
        statusCode: IterationStatusCode.CREATED,
        creation: {
          creationDateTime: '2024-04-19T10:05:42.156Z',
          creatorId: 'CVE',
          ownerId: 'CVE',
        },
        controls: [reputationalRiskDetails],
        customProperties: {
          reputationalRiskData: {
            quizFormValue: {
              alert: 'yes',
              controversial: 'no',
              guideline: 'yes',
              search: 'no',
            },
            riskFormValue: {
              averageRiskScore: '4',
              comment: 'Sending this to sales',
            },
            documentIds: ['doc-id-1'],
          },
        },
      } satisfies VettingIteration,
    },
  },
  {
    request: {
      method: 'GET',
      urlPathPattern: '^/iterations/iterationId/controls/ReputationalRisk$',
    },
    response: {
      status: 200,
      body: reputationalRiskDetails,
    },
  },
];
